import React from 'react';
import KemuSwitch from '@src/components/form-control/kemuSwitch/KemuSwitch';
import { GlobalVariable, CheckboxSettings } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import styles from '../GlobalVariablesPanel.module.css';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string,value: SupportedTypes, type: DataType) => void;
}

/**
 * Checkbox control component for global variables
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes
 */
const CheckboxControl = ({ variable, onChange }: Props) => {
  const settings = variable.controlSettings as CheckboxSettings;
  const currentValue = variable.lastValue as boolean ?? false;

  const handleChange = (checked: boolean) => {
    onChange(variable.name, checked, DataType.Boolean);
  };

  return (
    <KemuSwitch
      checked={currentValue}
      onChange={handleChange}
      size="default"
      className={styles.ControlSwitch}
    />
  );
};

export default CheckboxControl;
